import { Box, Center, Container, Text } from '@chakra-ui/react'
import {
	Routes,
	Route,
	Navigate
} from "react-router-dom";
import Form from './components/Form'
import Result from './components/Result'
import Background from './style/KfsysccLogo.87df6f3a.svg';

function App() {
	return (
		<Container
			maxW='container.xl'
			h="100vh"
			p={5}
			pb={"0px"}
			boxSizing="border-box"
			display="flex"
			flexDirection={"column"}			
		>
			<Box
				boxSizing="border-box"
				bgColor="gray.50"
				flexGrow={1}
				flexShrink={1}
				h="1px"
				w="100%"
				borderRadius={10}				
			>
				<Routes>
					<Route exact path="/" element={<Navigate to={'form'} replace />} />
					<Route
						path='/form'
						key='form'
						element={<Form />}
					/>
					<Route
						path='/result'
						key='result'
						element={<Result />}
					/>
				</Routes>
			</Box>
			<Box
				w="100%"
				flexGrow={0}
				flexShrink={0}
				h={{ base: "90px", md: "70px" }}
				display="flex"
				alignItems={"center"}
				justifyContent="center"
			>

				<Text align={"center"} fontSize={{ base: "sm", md: "md" }} letterSpacing={1}>
					醫療財團法人辜公亮基金會和信治癌中心醫院
					<br />
					台灣 台北市北投區立德路125號 電話：(02) 2897-0011 / (02) 6603-0011
				</Text>

			</Box>
		</Container >
	);
}

export default App;
